import { takeLatest } from 'redux-saga/effects';
import {
  FETCH_EVENTS_REQUEST,
  CREATE_EVENT_REQUEST,
  UPDATE_EVENT_REQUEST,
  DELETE_EVENT_REQUEST,
  FETCH_EVENT_DETAILS_REQUEST,
  FETCH_EVENT_TICKETS_REQUEST,
  FETCH_EVENT_TICKETS_EXCEL_REQUEST,
  CREATE_EVENT_BOOKING_ORDER_REQUEST,
  VERIFY_EVENT_PAYMENT_REQUEST,
} from '../../types/event';
import {
  fetchEventsWorker,
  createEventWorker,
  updateEventWorker,
  deleteEventWorker,
  fetchEventDetailsWorker,
  fetchEventsTicketsWorker,
  fetchEventsTicketsExcelWorker,
  createEventBookingOrderWorker,
  verifyEventPaymentWorker,
    fetchCategoriesWorker,
  createCategoryWorker,
  updateCategoryWorker,
  deleteCategoryWorker,
  fetchCategoryDetailsWorker,
} from '../workers/eventWorker';

import {
  FETCH_CATEGORIES_REQUEST,
  CREATE_CATEGORY_REQUEST,
  UPDATE_CATEGORY_REQUEST,
  DELETE_CATEGORY_REQUEST,
  FETCH_CATEGORY_DETAILS_REQUEST,
} from '../../types/category';

// Watcher Saga
// Listens for actions and triggers worker sagas
export default function* eventWatcher() {
  yield takeLatest(FETCH_EVENTS_REQUEST, fetchEventsWorker);
  yield takeLatest(CREATE_EVENT_REQUEST, createEventWorker);
  yield takeLatest(UPDATE_EVENT_REQUEST, updateEventWorker);
  yield takeLatest(DELETE_EVENT_REQUEST, deleteEventWorker);
  yield takeLatest(FETCH_EVENT_DETAILS_REQUEST, fetchEventDetailsWorker);
  yield takeLatest(FETCH_EVENT_TICKETS_REQUEST, fetchEventsTicketsWorker);
  yield takeLatest(FETCH_EVENT_TICKETS_EXCEL_REQUEST, fetchEventsTicketsExcelWorker);
  yield takeLatest(CREATE_EVENT_BOOKING_ORDER_REQUEST, createEventBookingOrderWorker);
  yield takeLatest(VERIFY_EVENT_PAYMENT_REQUEST, verifyEventPaymentWorker);
  yield takeLatest(FETCH_CATEGORIES_REQUEST, fetchCategoriesWorker),
  yield takeLatest(CREATE_CATEGORY_REQUEST, createCategoryWorker),
  yield takeLatest(UPDATE_CATEGORY_REQUEST, updateCategoryWorker),
  yield takeLatest(DELETE_CATEGORY_REQUEST, deleteCategoryWorker),
  yield takeLatest(FETCH_CATEGORY_DETAILS_REQUEST, fetchCategoryDetailsWorker)
}
